import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

import NavigationBarBusiness from "../components/navigation-bar-business";
import FAQBusiness from "../components/faq-business";
import ContactFormDark from "../components/contact-form-dark";
import Footer from "../components/footer";
import "./business.css";

const Business = (props) => {
  return (
    <div className="business-container1">
      <Helmet>
        <title>Business | CashOver Pay | Manage Your Finances</title>
        <meta
          name="description"
          content="CashOver Business provides a robust digital wallet solution for merchants and corporates across Lebanon—enabling fiat and cryptocurrency payments, seamless business transactions, fast payouts, and real‑time control over cash flows."
        />
        <meta
          property="og:title"
          content="Business - CashOver Pay | Digital Payment Solutions for You & Your Business | Lebanon"
        />
        <meta
          property="og:description"
          content="CashOver Business provides a robust digital wallet solution for merchants and corporates across Lebanon—enabling fiat and cryptocurrency payments, seamless business transactions, fast payouts, and real‑time control over cash flows."
        />
        <meta
          property="og:image"
          content="http://cashover.money/business%20hero.webp"
        />
      </Helmet>
      <NavigationBarBusiness
        text={
          <Fragment>
            <span className="business-text100">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="business-text101">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-businessroot-class-name"
      ></NavigationBarBusiness>
      <header className="business-column10">
        <div className="business-column11">
          <span className="business-text102">
            EVOLVE YOUR BUSINESS WITH CASHOVER
          </span>
          <h1 className="business-title">Lead the Digital Business Wave</h1>
          <h2 className="business-subtitle">
            Non-bank solutions for you, your employees, and customers. Receive
            money, pay salaries, and manage operations—all from one smart,
            secure platform.
          </h2>
          <div className="business-buttons">
            <Link
              to="/signup"
              className="business-action11 thq-button-filled-dark"
            >
              Get Started
            </Link>
            <a
              href="#Features"
              className="business-action2 thq-button-outline-dark"
            >
              Learn More
            </a>
          </div>
        </div>
        <div id="Services" className="business-row1">
          <svg viewBox="0 0 1024 1024" className="business-icon1">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
          <span className="business-text103">Scroll Down to Learn More</span>
          <svg viewBox="0 0 1024 1024" className="business-icon3">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
        </div>
      </header>
      <div className="business-column12">
        <div className="business-row2">
          <p className="business-text104">
            <span>Trusted By Hundreds of Businesses </span>
            <span>Across Lebanon</span>
          </p>
          <div className="business-row3">
            <div className="business-column13">
              <span className="business-text107">90%</span>
              <span className="business-text108">Customer Satisfaction</span>
            </div>
            <div className="business-column14">
              <span className="business-text109">1M+</span>
              <span className="business-text110">successful transactions</span>
            </div>
          </div>
        </div>
      </div>
      <div id="Features" className="business-column15">
        <h2 className="business-text111">
          <span className="business-text112">better</span>
          <span> than a bank</span>
        </h2>
        <div className="business-container2">
          <p className="business-text114">
            Discover Why You Should Have CashOver In Your Business
          </p>
          <Link
            to="/signup"
            className="business-action12 thq-button-filled-dark"
          >
            Get Started
          </Link>
        </div>
        <h2 className="business-text115">
          <span className="business-text116">cheaper</span>
          <span> </span>
          <span>than a bank</span>
        </h2>
        <div className="business-row4">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fsave%20time.mp4?alt=media&amp;token=869482d0-f298-4284-81d1-2a6653400cb9"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video1"
          ></video>
          <div className="business-column16">
            <div className="business-column17">
              <h2 className="business-text119">
                <span>Automated Payroll Processing</span>
                <br></br>
              </h2>
              <h3 className="business-text122">Efficiency and Time-Saving</h3>
              <p className="business-text123">
                <span>
                  Simplify
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text125">payroll</span>
                <span>
                  {" "}
                  with our automated system for timely and accurate salary
                  disbursements.
                </span>
                <br></br>
                <br></br>
                <span>
                  With
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text130">One-Tap Payments</span>
                <span> your business can r</span>
                <span>
                  educe administrative workload and save valuable time with
                  easy, one-tap salary payments.
                </span>
                <br></br>
                <br></br>
                <span>
                  Ensure precise payroll and
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text136">tax calculations</span>
                <span>, reducing the risk of errors and penalties.</span>
                <br></br>
              </p>
            </div>
          </div>
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fsave%20time.mp4?alt=media&amp;token=869482d0-f298-4284-81d1-2a6653400cb9"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video2"
          ></video>
        </div>
        <div className="business-row5">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fmoney.mp4?alt=media&amp;token=3f776730-32b7-47da-a016-51b0357a5d5f"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video3"
          ></video>
          <div className="business-column18">
            <div className="business-column19">
              <h2 className="business-text139">
                <span>Low Cost All Round Solution</span>
                <br></br>
              </h2>
              <h3 className="business-text142">Cost-Effective Fees</h3>
              <p className="business-text143">
                <span className="business-text144">Reduce overheads</span>
                <span>
                  {" "}
                  and save money with competitive transaction fees that are
                  lower than traditional banking fees.
                </span>
                <br></br>
                <br></br>
                <span className="business-text148">
                  Minimize administrative costs
                </span>
                <span>
                  {" "}
                  associated with manual payroll and tax calculations.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="business-row6">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fsecurity.mp4?alt=media&amp;token=15adf370-7bfa-4c58-aeb1-d7ed0cb8a149"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video4"
          ></video>
          <div className="business-column20">
            <div className="business-column21">
              <h2 className="business-text150">
                <span>Enhanced Security &amp; Storage</span>
                <br></br>
              </h2>
              <h3 className="business-text153">Secure Transactions</h3>
              <p className="business-text154">
                <span>
                  Protect your
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text156">financial data</span>
                <span>
                  {" "}
                  and transactions with advanced encryption and security
                  measures.
                </span>
                <br className="business-text158"></br>
                <br className="business-text159"></br>
                <span>
                  Mitigate
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text161">payroll fraud risks</span>
                <span> with our secure and transparent system.</span>
                <br></br>
                <br></br>
                <span className="business-text165">Secure your assets</span>
                <span> with our law compliant storage solutions.</span>
                <br></br>
              </p>
            </div>
          </div>
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fsecurity.mp4?alt=media&amp;token=15adf370-7bfa-4c58-aeb1-d7ed0cb8a149"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video5"
          ></video>
        </div>
        <div className="business-row7">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Feasy%20integration.mp4?alt=media&amp;token=810c400a-1fd1-4ec6-9ef1-2bb09d9bd399"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video6"
          ></video>
          <div className="business-column22">
            <div className="business-column23">
              <h2 className="business-text168">Seamless System Integration</h2>
              <h3 className="business-text169">Accounting Easier Than Ever</h3>
              <p className="business-text170">
                <span>
                  Integrating CashOver Business is seamless and hassle-free,
                  with a user-friendly interface that requires
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text172">
                  no extensive technical knowledge
                </span>
                <span> and ensures quick onboarding.</span>
                <br></br>
                <br></br>
                <span className="business-text176">
                  Scalable and compliant,
                </span>
                <span>
                  {" "}
                  CashOver Business grows with your needs, simplifying payroll,
                  taxes, and financial transactions.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="business-row8">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fsatisfaction.mp4?alt=media&amp;token=0b4f6cb5-4c76-4f9e-aa0e-b6fd88a219f7"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video7"
          ></video>
          <div className="business-column24">
            <div className="business-column25">
              <h2 className="business-text178">
                <span>Employee Satisfaction</span>
                <br></br>
              </h2>
              <h3 className="business-text181">Timely Payments</h3>
              <p className="business-text182">
                <span>
                  Improve employee satisfaction with timely, reliable
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text184">salary payments</span>
                <span>.</span>
                <br></br>
                <br></br>
                <span>
                  Employees can
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text189">withdraw</span>
                <span>
                  {" "}
                  their salaries from ATMs or Agents or can pay with CashOver
                  app from stores and websites.
                </span>
                <br className="business-text191"></br>
                <br className="business-text192"></br>
                <span>
                  Enhance trust and transparency with clear,
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text194">detailed e-payslips</span>
                <span> for employees.</span>
              </p>
            </div>
          </div>
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Fsatisfaction.mp4?alt=media&amp;token=0b4f6cb5-4c76-4f9e-aa0e-b6fd88a219f7"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video8"
          ></video>
        </div>
        <div className="business-row9">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/cashover-production.appspot.com/o/CashOver%20Website%20Videos%2Ffiles.mp4?alt=media&amp;token=091ed954-2d32-4771-a1c0-a0bd4c25e454"
           loop={true}
            muted={true}
            preload="auto"
           autoPlay={true}
           playsInline={true}
            className="business-video9"
          ></video>
          <div className="business-column26">
            <div className="business-column27">
              <h2 className="business-text196">
                <span>All Round Financial Solution</span>
                <br></br>
              </h2>
              <h3 className="business-text199">Cost-Effective Fees</h3>
              <p className="business-text200">
                <span>
                  CashOver Business
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text202">reduces paperwork</span>
                <span>
                  {" "}
                  and streamlines file management by
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text204">digitizing payroll</span>
                <span>
                  {" "}
                  and financial transactions.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <span>
                  No need for manual record-keeping, saving time and reducing
                  errors.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <span>
                  Enjoy organized,
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="business-text212">easily accessible</span>
                <span>
                  {" "}
                  digital records that simplify audits and reporting.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <FAQBusiness rootClassName="faq-businessroot-class-name1"></FAQBusiness>
      <ContactFormDark rootClassName="contact-form-darkroot-class-name4"></ContactFormDark>
      <Footer rootClassName="footerroot-class-name7"></Footer>
    </div>
  );
};

export default Business;
